module.exports = __webpack_public_path__ + "static/sam-altman-65fa6310a179489738f9285caa98b71a.jpg";